@if (authService.hasPermission(Permission.MasterSuitesFull)) {
  <div
  [matTooltip]="
    quantitySelected === 0
      ? 'Select Assets to transfer to EV Placeholders'
      : 'Transfer ' + quantitySelected + ' Selected Assets to EV Placeholders'
  "
    (click)="$event.stopPropagation()"
    >
    <button
      mat-icon-button
      (click)="onTransfer()"
      [disabled]="quantitySelected === 0"
      >
      <mat-icon>move_up</mat-icon>
    </button>
  </div>
}
